/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimReservationResponseDetails } from './ClaimReservationResponseDetails';
import {
    ClaimReservationResponseDetailsFromJSON,
    ClaimReservationResponseDetailsFromJSONTyped,
    ClaimReservationResponseDetailsToJSON,
} from './ClaimReservationResponseDetails';
import type { Timeslot } from './Timeslot';
import {
    TimeslotFromJSON,
    TimeslotFromJSONTyped,
    TimeslotToJSON,
} from './Timeslot';
import type { ClaimCenterWithBookables } from './ClaimCenterWithBookables';
import {
    ClaimCenterWithBookablesFromJSON,
    ClaimCenterWithBookablesFromJSONTyped,
    ClaimCenterWithBookablesToJSON,
} from './ClaimCenterWithBookables';

/**
 * 
 * @export
 * @interface ClaimReservationResponse
 */
export interface ClaimReservationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ClaimReservationResponse
     */
    claimFormAuthorized?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimReservationResponse
     */
    claimFormReceived?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClaimReservationResponse
     */
    claimFormId?: string | null;
    /**
     * 
     * @type {ClaimReservationResponseDetails}
     * @memberof ClaimReservationResponse
     */
    claimReservationDetails: ClaimReservationResponseDetails;
    /**
     * 
     * @type {Timeslot}
     * @memberof ClaimReservationResponse
     */
    timeslot: Timeslot;
    /**
     * 
     * @type {Date}
     * @memberof ClaimReservationResponse
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ClaimReservationResponse
     */
    id: string;
    /**
     * 
     * @type {ClaimCenterWithBookables}
     * @memberof ClaimReservationResponse
     */
    claimCenter: ClaimCenterWithBookables;
}

/**
 * Check if a given object implements the ClaimReservationResponse interface.
 */
export function instanceOfClaimReservationResponse(value: object): value is ClaimReservationResponse {
    if (!('claimReservationDetails' in value) || value['claimReservationDetails'] === undefined) return false;
    if (!('timeslot' in value) || value['timeslot'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimCenter' in value) || value['claimCenter'] === undefined) return false;
    return true;
}

export function ClaimReservationResponseFromJSON(json: any): ClaimReservationResponse {
    return ClaimReservationResponseFromJSONTyped(json, false);
}

export function ClaimReservationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimReservationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claimFormAuthorized': json['claimFormAuthorized'] == null ? undefined : json['claimFormAuthorized'],
        'claimFormReceived': json['claimFormReceived'] == null ? undefined : json['claimFormReceived'],
        'claimFormId': json['claimFormId'] == null ? undefined : json['claimFormId'],
        'claimReservationDetails': ClaimReservationResponseDetailsFromJSON(json['claimReservationDetails']),
        'timeslot': TimeslotFromJSON(json['timeslot']),
        'createdAt': (new Date(json['createdAt'])),
        'id': json['id'],
        'claimCenter': ClaimCenterWithBookablesFromJSON(json['claimCenter']),
    };
}

export function ClaimReservationResponseToJSON(value?: ClaimReservationResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimFormAuthorized': value['claimFormAuthorized'],
        'claimFormReceived': value['claimFormReceived'],
        'claimFormId': value['claimFormId'],
        'claimReservationDetails': ClaimReservationResponseDetailsToJSON(value['claimReservationDetails']),
        'timeslot': TimeslotToJSON(value['timeslot']),
        'createdAt': ((value['createdAt']).toISOString()),
        'id': value['id'],
        'claimCenter': ClaimCenterWithBookablesToJSON(value['claimCenter']),
    };
}

